/*
 * Цена консультации на стороне браузера.
 *
 * Правило одно и то же с сервером (backend/services/consultation_pricing.py):
 * до воскресенья 27.09.2026 включительно, по Москве, — 10 000 ₽, потом
 * снова 14 500 ₽. Дублируется здесь ради ПЕРВОГО КАДРА: страница рисует
 * цену сразу, не дожидаясь сети, иначе на месте суммы моргает пустота.
 *
 * Настоящая цена всё равно серверная: fetchConsultationPrice() спрашивает
 * /api/consultation/price, и её ответ вытесняет местный расчёт. Платёж в
 * ЮKassa заводится по серверной цене в любом случае — что бы ни показал
 * браузер с уехавшими часами.
 */

export const BASE_PRICE_RUB = 14500;
export const PROMO_PRICE_RUB = 10000;

// Конец акции: понедельник 28.09.2026, 00:00 по Москве = 27.09 21:00 UTC.
// Считаем в UTC, чтобы не зависеть от часового пояса на устройстве
// человека: у гостя из Владивостока акция обязана кончиться в тот же миг,
// что и у гостя из Калининграда.
const PROMO_ENDS_AT_MS = Date.UTC(2026, 8, 27, 21, 0, 0);

export const PROMO_NOTE = 'Акция до воскресенья 27 сентября — 3 места на этой неделе';

export function isPromoActive(now = Date.now()) {
  return now < PROMO_ENDS_AT_MS;
}

/** «14 500 ₽» — с пробелом в тысячах, как написано на всех страницах. */
export function formatPrice(amount) {
  return `${String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽`;
}

/** Что показывать до ответа сервера. */
export function localPrice(now = Date.now()) {
  const promo = isPromoActive(now);
  return {
    amount: promo ? PROMO_PRICE_RUB : BASE_PRICE_RUB,
    base_amount: BASE_PRICE_RUB,
    promo,
    promo_note: promo ? PROMO_NOTE : '',
  };
}

/**
 * Спросить цену у сервера. Сеть отвалилась — возвращаем местный расчёт:
 * страница без цены хуже, чем страница с ценой из того же правила.
 */
export async function fetchConsultationPrice(apiUrl) {
  try {
    const res = await fetch(`${apiUrl}/api/consultation/price`);
    if (!res.ok) return localPrice();
    const data = await res.json();
    if (!data || typeof data.amount !== 'number') return localPrice();
    return {
      amount: data.amount,
      base_amount: typeof data.base_amount === 'number' ? data.base_amount : BASE_PRICE_RUB,
      promo: Boolean(data.promo),
      promo_note: data.promo_note || '',
    };
  } catch (_) {
    return localPrice();
  }
}
